import qs from 'qs';
import {
  sendFormDataClient,
  callPostStringOperationEndpoint,
  multipartFormClient,
  isAxiosError,
  errorMessages,
  unexpectedStatusCodeMessage,
} from './api-main';
import { DeleteJobPayload } from '../models/job/DeleteJobPayload';
import {
  SUCCESS_RESPONSE,
  StringOperationResponse,
} from '../models/base/StringOperationResponse';
import { JobSearchPayload } from '../models/job/JobSearchPayload';
import { JobSearchResult } from '../models/job/JobSearchResult';
import { JobContract } from '../models/job/JobContract';

export const postSearchJob = async (
  payload: JobSearchPayload,
): Promise<JobSearchResult[]> => {
  try {
    // Convert the parameters to URL-encoded string
    const parameters = qs.stringify(payload);
    const { data } = await sendFormDataClient.post('/job/search', parameters);
    console.debug('Job search response:', data);
    return data as JobSearchResult[];
  } catch (error) {
    console.error('Error searching for job:', error);
    throw error;
  }
};

export const startJobWithZipAndPayload = async (
  body: FormData, // send multipart form data with payload and file
): Promise<StringOperationResponse> => {
  try {
    const response = await multipartFormClient.post(
      `/batchRating/startJobWithZipAndPayload`,
      body,
    );
    console.debug('Upload response:', response);
    if (response?.data === SUCCESS_RESPONSE) {
      return { success: true, userMessage: 'Operation successful.' };
    } else {
      return { success: false, userMessage: response?.data };
    }
  } catch (error) {
    if (!isAxiosError(error)) {
      return { success: false, userMessage: `Unexpected error: ${error}` };
    }
    // else is an axios error
    const myErrorCode: number = error.response?.status || 0;
    const knownErrorCodes = Object.keys(errorMessages).map((k) => parseInt(k));
    let userMessage = unexpectedStatusCodeMessage(myErrorCode);
    if (knownErrorCodes.includes(myErrorCode)) {
      userMessage = errorMessages[error.response?.status as number];
    }
    const detailedErrorMessage = ` Error in endpoint: /batchRating/startJobWithZipAndPayload: ${error}.`;
    console.error(userMessage + detailedErrorMessage);
    return { success: false, userMessage };
  }
};

export const postDeleteJob = async (
  payload: DeleteJobPayload,
): Promise<StringOperationResponse> => {
  return await callPostStringOperationEndpoint({
    endpointPath: '/job/deleteJob',
    payload,
    client: sendFormDataClient,
  });
};

export const getContractsForJob = async (
  securityToken: string,
  jobId: string,
): Promise<JobContract[]> => {
  try {
    const params = { token: securityToken, jobId };
    const queryParams = qs.stringify(params);
    const { data } = await sendFormDataClient.get(
      `/job/getContractsForJob?${queryParams}`,
    );
    console.debug('Contracts response:', data);
    return data as JobContract[];
  } catch (error) {
    console.error('Error fetching contracts for job:', error);
    throw error;
  }
};

export const postDeleteContract = async (
  securityToken: string,
  contractPk: string,
  jobId: string,
): Promise<StringOperationResponse> => {
  const payload = { token: securityToken, contractPk, jobId };
  return await callPostStringOperationEndpoint({
    endpointPath: '/job/deleteContract',
    payload,
    client: sendFormDataClient,
  });
};
